import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {Modal, Form, Input, InputNumber, Select, message} from 'antd';
import {getStocksById, updateStock} from "../../../lib/api_stock";
import DictSelect from "../../../components/dict/dict-select";
import CoaSelect from "../../manage/cw/coa_select3";
import moment from "moment";

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 6},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
    },
};

const Stock_edit_modal = ({id, onCancel, onOk, year}) => {
    const [form] = Form.useForm();
    const [selectedType, setSelectedType] = useState(1);

    const handleTypeChange = (value) => {
        setSelectedType(value);
    };

    const fetchData = () => {
        getStocksById(id)
            .then(res => {
                if (res.code === 0) {
                    form.setFieldsValue(res.data);
                    setSelectedType(res.data.type || 1);
                } else {
                    message.error(res.message);
                    onCancel && onCancel();
                }
            })
    }

    useEffect(fetchData, []);

    const handleSubmit = () => {
        form.validateFields()
            .then(values => {
                values.id = id;
                updateStock(values)
                    .then(res => {
                        if (res.code === 0) {
                            onOk && onOk();
                        }
                    })
            })
    };

    const handleCancel = () => {
        onCancel && onCancel();
    };
    return (
        <Modal
            title="修改库存信息"
            visible={true}
            onOk={handleSubmit}
            onCancel={handleCancel}
            destroyOnClose={true}
        >
            <Form
                form={form}
                {...formItemLayout}
                initialValues={{}}
            >
                <Form.Item
                    label="类型"
                    name="type"
                    rules={[
                        {
                            required: true,
                            message: '请选择类型',
                        },
                    ]}
                >
                    <Select 
                        options={[
                            {label: '普通商品', value: 1},
                            {label: '组合套餐', value: 2}
                        ]} 
                        placeholder="请选择类型"
                        onChange={handleTypeChange}
                        disabled={true}
                    />
                </Form.Item>
                <Form.Item
                    label="SKU编号"
                    name="sku_id"
                >
                    <Input placeholder="请输入SKU编号"/>
                </Form.Item>
                {selectedType === 1 && (
                    <Form.Item
                        label="所属科目"
                        name="coa_id"
                    >
                        <CoaSelect year={year}/>
                    </Form.Item>
                )}
                <Form.Item
                    label="名称"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: '请输入名称',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="分类"
                    name="category"
                    rules={[
                        {
                            required: true,
                            message: '请选择分类',
                        },
                    ]}
                >
                    <DictSelect type_value="stocks_category" placeholder="请选择分类"/>
                </Form.Item>
                <Form.Item
                    label="规格"
                    name="specification"
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="数量"
                    name="quantity"
                    rules={[
                        {
                            required: true,
                            message: '请输入数量',
                        }
                    ]}
                >
                    <InputNumber style={{width: '100%'}}/>
                </Form.Item>
                <Form.Item
                    label="单位"
                    name="unit"
                    rules={[
                        {
                            required: true,
                            message: '请选择单位',
                        }
                    ]}
                >
                    <DictSelect type_value="stocks_unit" placeholder="请选择单位"/>
                </Form.Item>
                <Form.Item
                    label="单价"
                    name="price"
                    rules={[
                        {
                            required: true,
                            message: '请输入单价',
                        }
                    ]}
                >
                    <InputNumber style={{width: '100%'}} precision={2}/>
                </Form.Item>
                <Form.Item
                    label="供应商"
                    name="supplier"
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="备注"
                    name="remark"
                >
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default Stock_edit_modal;
